export default __webpack_public_path__ + "5620900b8e8da2923eefe7c9c7efe940.png";